import * as React from 'react'
import useLanguage from '../lib/state/lang-state';

const LangButton = ({label}) => {
    const { lang, setLanguage } = useLanguage();

    const changeLang = () => setLanguage(label);

    if (lang === label) {
        return (
            <div className='w-7 h-7 rounded-full text-sm text-white bg-red-500 flex items-center justify-center cursor-default'>
                <div>{label}</div>
            </div>
        )
    }
    else {
        return (
            <div className='w-7 h-7 rounded-full text-sm border border-gray-700 flex items-center justify-center cursor-default' onClick={changeLang}>
                <div>{label}</div>
            </div>
        )
    }
}

export default LangButton;
